module.exports = __webpack_public_path__ + "img/boom3.fbfebae2.png";